<template lang="pug">
  .page.page_offset_top.page_offset_bottom
    .page-meta
      .container
        .page-meta__inner.page-meta__inner_top
          breadcrumbs
          social.page-meta__social-list(theme="blue")
    .page-news
      .container
        .page-mediacenter__container
          h1.title.title_size_l.text_center.page-news__title Новости
          .news-card-list
            router-link.news-card-item.news-card-item_single(to="/mediacenter/news/news-inner")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title BelkaCar начинает работать в Сочи
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack …
              .news-card-item__image
                img(src="/static/img/news-1.jpg", alt="")

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack Основатели крупнейшего российского каршеринга

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-3.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С
            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С
            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С

            router-link.news-card-item.news-card-item_single(to="/mediacenter/news/news-inner")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title BelkaCar начинает работать в Сочи
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack …
              .news-card-item__image
                img(src="/static/img/news-1.jpg", alt="")

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack Основатели крупнейшего российского каршеринга

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-3.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12 июля 2018 года премиальный сервис BelkaBlack Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С 12

            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С
            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С
            router-link.news-card-item(to="/mediacenter/news/news-inner")
              .news-card-item__image
                img(src="/static/img/news-2.jpg", alt="")
              .news-card-item__content
                time.news-card-item__date 27 августа 2018
                h3.title.title_size_m.news-card-item__title Каршеринг BelkaCar пополнил автопарк новыми KIA Rio X-Line
                p.text.text_theme_gray.news-card-item__text Основатели крупнейшего российского каршеринга BelkaCar объявили о запуске сервиса в Сочи. С
</template>

<script>
import Social from './../components/Social'

export default {
  name: 'News',
  components: { Social },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/News.vue